const commonActionTypes = {
  SELECT_MENU: 'SELECT_MENU',
};

export default commonActionTypes;
